<mat-form-field class="full-width">
  <mat-label [innerHTML]="label"></mat-label>
  <input [formControl]="formCtrl"  [readonly]="readOnlyInd" matInput [matTooltip]="toolTip" [placeholder]="placeHolder" title="{{placeHolder}}" />
  <button type="button" *ngIf="formCtrl.value!=='' && readOnlyInd===false" 
    matSuffix aria-label="Clear"
    [hidden]="disableClearBtn"
    (click)="clearControl()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="formCtrl.errors">{{errormessage}}</mat-error>
</mat-form-field>